//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { api_getHldList } from "../../../api";
// import {conversion} from "../../../tool";
import { format_date } from "@/filters/format_date.js"

export default {
	data() {
		return {
			commissionData: {
				data: { list: [] },
				current: 1,
				size: 15
			},
		}
	},
	methods: {
		format_date,
		//翻页接口
		getuserCommission(obj) {
			api_getHldList({
				pageIndex: obj.page - 1,
				pageSize: obj.size,
				type: '',
				// start: '20240101',
			}).then(res => {
				if (res.status === 200) {
					this.commissionData.data.list = res.data.items;
					this.commissionData.data.total = res.data.totalItems;
					// this.commissionData.data.list = [
					// 	{
					// 		"id": "8a02bf5a-bdd9-4a63-a68d-8c2889843f82",
					// 		"createdAt": "2024-07-11T16:55:44.557Z",
					// 		"type": "Crash",
					// 		"detail": "Crash 减额",
					// 		"amount": -500,
					// 		"balance": 12194.4
					// 	},
					// ]
				}
			});
		},
		//翻页
		pageF(v) {
			this.getuserCommission({ page: v, size: this.commissionData.size });
		},
	},

	created() {
		this.getuserCommission({
			page: this.commissionData.current,
			size: this.commissionData.size
		});
	},
	name: "walletHistory"
}
